import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-mail2SmsConfig-detail',
  templateUrl: './mail2SmsConfig-detail.component.html'
})
export class Mail2SmsConfigDetailComponent implements OnInit {
  mail2SmsConfig:any;
  defaultConfig:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.http.get(`${this.env.e.url}/mail2sms/mail2SmsConfigs/default`).subscribe(
            data => {
              this.setDefaultConfig(data);
              this.createNew();
            }
          );
        } else {
          this.http.get(`${this.env.e.url}/mail2sms/mail2SmsConfigs/default`).subscribe(
            data => {
              this.setDefaultConfig(data);
              this.http.get(`${this.env.e.url}/mail2sms/mail2SmsConfigs/${id}`).subscribe(
                data => {
                  this.setMail2SmsConfig(data)
                }
              );
            }
          );
        }
      });
  }

  setDefaultConfig(config:any) {
    this.defaultConfig = config;
  }

  setMail2SmsConfig(mail2SmsConfig:any) {
    this.mail2SmsConfig = mail2SmsConfig;
    mail2SmsConfig.postmasterId = mail2SmsConfig.postmasterId === null ? undefined : mail2SmsConfig.postmasterId;
    mail2SmsConfig.smsEmailDomain = mail2SmsConfig.smsEmailDomain === null ? undefined : mail2SmsConfig.smsEmailDomain;
    mail2SmsConfig.waEmailDomain = mail2SmsConfig.waEmailDomain === null ? undefined : mail2SmsConfig.waEmailDomain;
    mail2SmsConfig.waMsisdn = mail2SmsConfig.waMsisdn === null ? undefined : mail2SmsConfig.waMsisdn;
    mail2SmsConfig.defaultMoToEmailOnlyNoRecipient = mail2SmsConfig.defaultMoToEmailOnlyNoRecipient === null ? undefined : mail2SmsConfig.defaultMoToEmailOnlyNoRecipient;
    mail2SmsConfig.autoMoToLastEmail = mail2SmsConfig.autoMoToLastEmail === null ? undefined : mail2SmsConfig.autoMoToLastEmail;
    mail2SmsConfig.autoMoToLastEmailHours = mail2SmsConfig.autoMoToLastEmailHours === null ? undefined : mail2SmsConfig.autoMoToLastEmailHours;
    mail2SmsConfig.autoMoToMaxLastEmails = mail2SmsConfig.autoMoToMaxLastEmails === null ? undefined : mail2SmsConfig.autoMoToMaxLastEmails;
    mail2SmsConfig.mailWorkerThreads = null;
    mail2SmsConfig.moWorkerThreads = null;
    mail2SmsConfig.postmasterWorkerThreads = null;
  }

  createNew() {
    this.mail2SmsConfig = {
      mailWorkerThreads: null,
      moWorkerThreads: null,
      postmasterWorkerThreads: null,
    };

    if (!this.authService.hasRole("COMPANY_ADMIN") && !this.authService.isSystemUser())
      this.mail2SmsConfig.companyId = this.authService.getCompanyId();
  }

  save() {
    if (!this.mail2SmsConfig.id) {
      this.http.post(`${this.env.e.url}/mail2sms/mail2SmsConfigs`, this.mail2SmsConfig)
        .subscribe(
          data => {
            this.setMail2SmsConfig(data)
            this.alertService.info(`Created ${this.mail2SmsConfig.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/mail2sms/mail2SmsConfigs/${this.mail2SmsConfig.id}`, this.mail2SmsConfig)
        .subscribe(
          data => {
            this.setMail2SmsConfig(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/mail2sms/mail2SmsConfigs/${this.mail2SmsConfig.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.mail2SmsConfig.name}`);
          this.router.navigate(["/mail2msg/configs"]);
        }
      );
  }

  isValidEmail(email:any) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
}
